import React from 'react';
import AccordionBtn from 'components/commercetools-ui/atoms/accordion';
import { GenericSectionContent } from '../../types';
import { useAdditionalCss } from '../../../helpers/useAdditionalCss';
import { sanitizeHtml, SECTION_SPACING } from '../../../helpers/rendering';

// FAQs ← Methven `faq-section`: right-aligned 12-col grid heading + accordion list (HTML answers).
export default function FAQsRendering({ content }: { content: GenericSectionContent }) {
  const { title, faqs = [], additional_css, additional_css_class_names } = content;
  const { uniqueClass, scopedAdditionalCss } = useAdditionalCss(additional_css, 'FAQsRendering');

  return (
    <>
      {scopedAdditionalCss && <style dangerouslySetInnerHTML={{ __html: scopedAdditionalCss }} />}
      <div id="faq-section" className={`${SECTION_SPACING} px-40 md:px-48 lg:px-80 2xl:px-120 ${[additional_css_class_names, uniqueClass].filter(Boolean).join(' ')}`}>
        <p className="mb-12 border-b border-neutral-400 pb-8 text-32 font-semibold leading-[2.375rem] text-primary-black sm:leading-[3.5rem] lg:mb-16 lg:border-none 2xl:mb-24 xl:text-36 2xl:text-48">
          {title || 'FAQs'}
        </p>
        {faqs.map((faq, index) => (
          <AccordionBtn
            key={index}
            titleTag="h3"
            closedSectionTitle={faq?.question}
            className="border-b border-neutral-400"
            buttonClassName="!px-0 !py-16 lg:!py-20 text-left text-16 leading-normal font-normal text-[24px] !font-semibold !leading-[2.1rem] text-[#090909] md:!leading-[2rem]"
            panelClassName="px-6 pb-12 pt-6 text-18 font-normal leading-7 text-[#333] xl:text-16 2xl:text-18"
          >
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(faq?.answer) }} />
          </AccordionBtn>
        ))}
      </div>
    </>
  );
}
